<template>
    <v-container transparent>
        <v-layout>
            <v-card width="100%" flat>


                <v-form v-model="testRegFormValid">
                    <v-container class="pa-5">
                        <v-flex offset-lg2 offset-md3 lg8 md6 xs12 align-center justify-space-between>
                            <v-card-title primary-title class="py-4 title">
                                Зарегистрировать тест
                            </v-card-title>


                                <v-container>
                                    <v-layout>
                                        <v-flex xs12 md12 style="text-align: center">
                                            Введите код (ZK-XXXXXX-XXXXXX) 997B00-11010H с карточки без префикса ZK-
                                        </v-flex>
                                    </v-layout>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-text-field id="testRegKey" prepend-icon="vpn_key" name="test_reg_key" class="notranslate"
                                                          label="Код в формате XXXXXX-XXXXXX" v-model="testReg.key"
                                                          mask="NNNNNN-NNNNNN"
                                                          :rules="[rules.required]"
                                                          type="text"
                                                          required></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field prepend-icon="email" class="v-text-field-email notranslate" name="email"
                                                          label="Email"
                                                          :rules="[rules.required, rules.email]"
                                                          type="email" v-model="testReg.email"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4 md3>
                                            <v-btn block large color="primary"
                                                   :disabled="!testRegFormValid"
                                                   @click="addTestCode">Сохранить</v-btn>
                                        </v-flex>
                                        {{testReg.part1}}
                                    </v-layout>
                                </v-container>

                        </v-flex>
                    </v-container>
                </v-form>


            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "RegTest",
        data: () => ({
            testRegFormValid: false,
            testRegFormIsDirty: false,
            testReg: {
                key: "",
                email: "",
                formatted: ""
            },
            utility: {
            },
            rules: {
                required: value => !!value || 'Required.',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            }
        }),
        watch: {
             'testReg.key': {
                handler: function (val) {
                    this.testReg.formatted = val.slice(0,6) + '-' + val.slice(6)
                }
            }
        },
        methods: {
            addTestCode: function () {
                var this_ = this;
                let key = this_.testReg.formatted
                this.$store.dispatch('adminAddTestCode', { key, email: this_.testReg.email }).then(function (response) {
                    this_.response = response
                    this_.$store.dispatch('processError', this_.response)
                })
            },
        },
        computed: {
            profileFormCanSave: function () {
                if (this.profileFormValid && this.isProfileFormIsDirty) return true;
                return false;
            }
        }/*,
        created: function () {
        }*/

    }
</script>

<style type="scss" scoped>
    .v-text-field-email {
        input {
            color: red;
        }
    }
</style>